import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=27e1896b&scoped=true"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"
import style0 from "./setup.vue?vue&type=style&index=0&id=27e1896b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1896b",
  null
  
)

export default component.exports